import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { PageVariant } from '@/features/home/domain/models/HomeVariant';

interface HomeVariantState {
  variant: PageVariant;
  rawVariant: string | null | undefined;
}

const initialState: HomeVariantState = {
  variant: 'V1',
  rawVariant: undefined,
};

const homeVariantSlice = createSlice({
  name: 'homeVariant',
  initialState,
  reducers: {
    setHomeVariant(state, action: PayloadAction<PageVariant>) {
      state.variant = action.payload;
    },
    setRawHomeVariant(state, action: PayloadAction<string | null | undefined>) {
      state.rawVariant = action.payload;
    },
  },
});

export const { setHomeVariant, setRawHomeVariant } = homeVariantSlice.actions;
export const homeVariantReducer = homeVariantSlice.reducer;
export const HOME_VARIANT_SLICE_NAME = homeVariantSlice.name;
